/**
 * Keys that may be restored from Auth0 `submitted_form_data`.
 *
 * Secret fields (passwords, consent) are omitted so they cannot be passed
 * to {@link getSubmittedString}.
 */
export type RestorableSubmittedKey =
  | "email"
  | "username"
  | "ulp-given-name"
  | "ulp_given_name"
  | "ulp-family-name"
  | "ulp_family_name";

/**
 * Restores a submitted string from Auth0 `submitted_form_data`.
 *
 * Tries keys in order so callers can accept aliases (e.g. SDK `username`
 * then Auth0 `email`). Non-string values are skipped.
 */
export function getSubmittedString(
  submittedFormData: Record<string, unknown> | null,
  ...keys: RestorableSubmittedKey[]
): string {
  for (const key of keys) {
    const value = submittedFormData?.[key];
    if (typeof value === "string") {
      return value;
    }
  }

  return "";
}
